import React, { useCallback } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";
import { getFreightModeLabel } from "helpers/freightModeHelper";
import usePermissions from "hooks/usePermissions";
import getLabel from "helpers/getLabel";

function Shipment(props: any) {
  const { state } = props;
  const intl = useIntl();
  const methods = useFormContext();
  const { getValues } = methods;
  const { getPaymentLocationLabel } = usePermissions();

  const getPaymentLocation = useCallback(() => {
    const keys = [getValues("shipment.location")];
    return keys.map((key: any) => state.paymentLocations[key]);
  }, [state.paymentLocations]);
  
  const providers = state?.providers?.[0] ?? [];
  const selectedProviderName = providers.find((provider: any) => provider.value === getValues("shipment.provider"))?.label;

  const freightModeLabel: any = getFreightModeLabel(intl);
  const freightModeValue = getValues("shipment.freight_mode");

  return (
    <div className="font-b3">
      <Row>
        <Card.Body>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage
                id="general.shipmentTitle"
                defaultMessage="Shipment Title"
                values={{ shipmentTitle: getLabel("Shipment title", "capitalize-first") }}
              />
            </Col>
            <Col>{getValues("shipment.title") || "-"}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">{getPaymentLocationLabel()}</Col>
            <Col>{getPaymentLocation()[0]?.label}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="general.freightMode" defaultMessage="Freight mode" />
            </Col>
            <Col>{freightModeLabel[freightModeValue] || "-"}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="quote-request.trackingType" defaultMessage="Tracking type" />
            </Col>
            <Col>{getValues("shipment.tracking_type") || "-"}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="quote-request.trackingNumber" defaultMessage="Tracking number" />
            </Col>
            <Col>{getValues("shipment.tracking_number") || "-"}</Col>
          </Row>
          <Row className="mb-2">
            <Col className="text-secondary">
              <FormattedMessage id="general.provider" defaultMessage="Provider" />
            </Col>
            <Col>{selectedProviderName || "-"}</Col>
          </Row>
        </Card.Body>
      </Row>
    </div>
  );
}

export default Shipment;
